import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
} from "@material-ui/core";
import { updateQuestionSetting } from "../../actions";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  section: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));
function ReadonlyFunction() {
  const { question, questionId, languages } = useSelector((state) => ({
    question: state.question_checked_settings,
    questionId: state.question_checked,
    languages: state.languages,
  }));
  const dispatch = useDispatch();
  const classes = useStyles();
  return (
    <>
      <FormGroup className={classes.section}>
        <FormControlLabel
          control={
            <Checkbox  />
          }
          label="Enable readonly: "
          style={{marginBottom:0, justifyContent:"space-between"}}
          labelPlacement="start"
          checked={question.readonly === "" ? false : question.readonly}
          onChange={(e) => {
            dispatch(
              updateQuestionSetting(
                questionId,
                "readonly",
                e.target.checked
              )
            );
          }}
          name={`${questionId}_readonly`}
        />
      </FormGroup>
      <Divider />
    </>
  );
}

export default ReadonlyFunction;
